import { render, staticRenderFns } from "./ByMemory.vue?vue&type=template&id=6bfecd53&scoped=true"
import script from "./ByMemory.vue?vue&type=script&lang=js"
export * from "./ByMemory.vue?vue&type=script&lang=js"
import style0 from "./ByMemory.vue?vue&type=style&index=0&id=6bfecd53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfecd53",
  null
  
)

export default component.exports